import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TopNavComponent} from './top-nav/top-nav.component';
import {AlarmComponent} from './alarm/alarm.component';
import {DropDownMenuComponent} from './drop-down-menu/drop-down-menu.component';
import {DropDownGroupMenuComponent} from './drop-down-group-menu/drop-down-group-menu.component';
import {UserInfoComponent} from './user-info/user-info.component';
import {UserInfoListComponent} from './user-info-list/user-info-list.component';
import {NavDropDownComponent} from './nav-drop-down/nav-drop-down.component';
import {DropDownGroupMenuPlusComponent} from './drop-down-group-menu-plus/drop-down-group-menu-plus.component';
import {HelpInfoListComponent} from './help-info-list/help-info-list.component';


@NgModule({
    declarations: [
        TopNavComponent,
        AlarmComponent,
        DropDownMenuComponent,
        DropDownGroupMenuComponent,
        DropDownGroupMenuPlusComponent,
        NavDropDownComponent,
        UserInfoComponent,
        UserInfoListComponent,
        HelpInfoListComponent,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TopNavComponent,
        AlarmComponent,
        DropDownMenuComponent,
        UserInfoComponent,
        UserInfoListComponent,
        DropDownGroupMenuComponent,
        DropDownGroupMenuPlusComponent,
        NavDropDownComponent,
        HelpInfoListComponent,
    ]
})
export class NavModule {
}
